module.exports = __webpack_public_path__ + "media/images/ui__themeToggleLight-159796f5f875834390a67e37e8edbedf.png";